/**
 * Daily-practice copy from the user's REAL current streak (the canonical
 * gamification overview). Unknown (not loaded / failed) → no number at all.
 */
export function streakMessage(currentStreak: number | null | undefined): string {
  if (typeof currentStreak !== 'number' || !Number.isFinite(currentStreak)) {
    return 'A few minutes of practice every day builds a streak.';
  }
  if (currentStreak <= 0) {
    return 'Practice today to start a new streak.';
  }
  return `Practice today to keep your ${currentStreak}-day streak going.`;
}
